import React, { Component } from 'react';
import { injectIntl } from 'react-intl';
import { observer } from 'mobx-react';
import messages from '../ForInvestors.intl';
import LanguageService from 'services/Language.service';
import TradingViewWidget, { Themes } from 'react-tradingview-widget';
import { EXTERNAL_LINK } from 'common/consts/common';
import GPWLogo from 'common/images/gpw.jpg';
import styles from './StockPriceChart.module.scss';

@injectIntl
@observer
export default class StockPriceChart extends Component {
  componentDidMount() {
    // TODO: when API will be available, fetch chart data here
  }

  render() {
    const language = LanguageService.getLang();
    return (
      <>
        <section className={styles.HeaderWrapper}>
          <h2 className={styles.Header}>
            {this.props.intl.formatMessage(messages.stockPriceChartTitle)}
          </h2>
          <a
            href={EXTERNAL_LINK.GPW}
            title="GPW"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src={GPWLogo} className={styles.GPWLogo} alt="GPWLogo" />
          </a>
        </section>
        <div className={styles.StockPriceChart}>
          <TradingViewWidget
            symbol="GPW:THG"
            theme={Themes.LIGHT}
            locale={language}
            height={300}
            width="auto"
            interval={'D'}
          />
          <div className={styles.WidgetCopyright}>
            <p>
              <a
                href="https://www.tradingview.com/symbols/GPW-THG/"
                target="_blank"
                rel="noreferrer"
              >
                {this.props.intl.formatMessage(messages.thgFromWidget)}
              </a>
              {this.props.intl.formatMessage(messages.widgetCopyright)}
            </p>
          </div>
        </div>
      </>
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/ForInvestors/components/StockPriceChart.js